// External libraries
import { css } from '@emotion/core';

// Internal modules
import { HEADER_COLOR } from '@/styles';

const getNameContainerStyleOverrides = noMargin => css`
  margin-bottom: ${noMargin ? 0 : '4px'};

  @media (min-width: 365px) {
    margin-bottom: ${noMargin ? 0 : '12px'};
  }
`;

const guestContactStyles = css`
  margin-bottom: 24px;

  > div:not(:last-child) {
    margin-bottom: 12px;
  }
`;

const returnAfterSubmitStyles = css`
  color: ${HEADER_COLOR};
  font-size: 11px;
  font-weight: 600;
  line-height: 1.36;
  margin: 32px 0 12px;
  text-align: center;
`;

export {
  getNameContainerStyleOverrides,
  guestContactStyles,
  returnAfterSubmitStyles,
};
